module.exports = __webpack_public_path__ + "static/media/camara.91a4eb28.png";